import { env } from '@/config/env';

const ModeSwitcher = () => {
  if (env.showModeSwitcher !== 'true') return null;

  const isSandbox = env.isSandbox === 'true';

  return (
    <div className="flex items-center justify-between gap-2 border-t px-4 py-2.5">
      {isSandbox ? (
        <span className="text-error border-error inline-flex items-center rounded-full border px-3 py-1 text-sm font-medium">
          Sandbox
        </span>
      ) : (
        <a
          href={env.sandboxDashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sidebar-sandbox-link"
          className="text-brand-gray inline-flex items-center gap-1 px-3 py-1.5 text-sm font-semibold transition-colors"
        >
          Sandbox
        </a>
      )}
      {isSandbox ? (
        <a
          href={env.productionDashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sidebar-production-link"
          className="text-brand-gray inline-flex items-center gap-1 px-3 py-1.5 text-sm font-semibold transition-colors"
        >
          Production
        </a>
      ) : (
        <span className="text-success border-success inline-flex items-center rounded-full border px-3 py-1 text-sm font-medium">
          Production
        </span>
      )}
    </div>
  );
};

export default ModeSwitcher;
